define('masonryLayout',['jquery','lib-masonry'],
function ($, Masonry) {

    var dom = {
        masonryGrid: $('.masonry-grid')
    };

    if (dom.masonryGrid.length) {
        dom.masonryGrid.each(initMasonry);

        function initMasonry() {
            var masonryInitiated = false;
            var masonry = '';
            var itemsPerPage = 18;
            var items = [];
            var remainingItems = [];
            var $searchResources = $('.search-result-resources');
            var curPageIsResourcePage = $searchResources.length;
            var fetchAndShowMore = false;

            // Check if on the resource page. If we are, we need to fetch data from server
            if (curPageIsResourcePage) {
                var $showMoreBtn = $('.show-more');
                $searchResources.SearchResult($('.search-filter'), {
                    datapath: '/api/Resources',
                    template: $('.template').html(),
                    noResultHtml: $('.search-noresults').clone()
                });

                $(document).on('searchJSON_done', function(){
                    updateMasonry();
                });

                $(document).on('show_more', function(){
                    showMore();
                });

                // If fetch_show_more event is fired, we know that all items were just fetched, by a click on 'show more'.
                // Masonry needs to reload all items, and then we need to show 36 items
                // We cant just call showMore(), since that function assumes that all - not only the first 18 items - are already fetched
                $(document).on('fetch_show_more', function(){
                    fetchAndShowMore = true;
                    updateMasonry();
                });

            } else {
                if ($(this).hasClass('masonry-toggle')) {
                    $(this).on('updateLayout', function () {
                        updateMasonry(this);
                    });
                } else {
                    updateMasonry(this); // 'this' is the masonry element
                }
            }

            function updateMasonry(masonryElement) {
                if (!masonryInitiated) {
                    if (typeof masonryElement === 'undefined') {
                        masonryElement = $('.masonry-grid')[0];
                    }
                    masonry = new Masonry( masonryElement, {
                        itemSelector: '.grid-item',
                        columnWidth: '.grid-item',
                        percentPosition: true,
                        gutter: '.grid-gutter',
                        transitionDuration: 0
                    });
                    masonryInitiated = true;
                    masonry.on( 'layoutComplete', function( laidOutItems ) {
                        if (laidOutItems.length === 1) {
                            $(laidOutItems[0].element).addClass("added");
                        }
                    });
                } else {
                    masonry.reloadItems();

                    if (curPageIsResourcePage) {
                        var itemsToShow = itemsPerPage;
                        // Get array of masonry items
                        items = masonry.items;

                        if (fetchAndShowMore) {
                            fetchAndShowMore = false;
                            itemsToShow = itemsPerPage * 2;
                        }

                        // if items are more than 18, we only show 18, and subsequently load more on 'view more' button press
                        if (items.length > itemsToShow) {
                            // Remaining items are whats left, after the first 18 items are removed
                            remainingItems = items.slice(itemsToShow);
                            // Remove all the remaining items from our Masonry object
                            remainingItems.forEach(function(element) {
                                masonry.remove(element.element);
                            });
                            // Show the 'show more' button
                            $showMoreBtn.addClass('active');
                        } else {
                            $showMoreBtn.removeClass('active');
                        }
                    }

                    // Layout Masonry, based on the elements in masonry.items
                    masonry.layout();
                }
            }

            function showMore() {
                // By splicing, we remove elements from remainingItems + add the removed elements to itemsToAdd
                var itemsToAdd = remainingItems.splice(0, itemsPerPage);

                itemsToAdd.forEach(function(element) {
                    // Add items to dom, then tell masonry that items were added, so it can relayout
                    $(element.element).addClass("adding");
                    $searchResources.append(element.element);
                    masonry.appended(element.element);
                });
                if (remainingItems.length === 0) {
                    $showMoreBtn.removeClass('active');
                }
            }
        }
    }
});

